import * as actionTypes from './actionTypes';
import { ProductWhereIn } from '../../api';
import { store } from '../../index';
import { checkToken } from '../redux-actions/auth-action';

// Action untuk menyimpan produk yang diambil
export const fetchProduct = (products) => ({
  type: actionTypes.FETCH_PRODUCT,
  products,
});

// Action untuk menandai awal proses pengambilan produk
export const startFetchProduct = () => ({
  type: actionTypes.START_FETCHPRODUCT,
});

// Action untuk menandai keberhasilan pengambilan produk
export const successFetchProduct = () => ({
  type: actionTypes.SUCCESS_FETCHPRODUCT,
});

// Action untuk menyetel total harga
export const setTotalPrice = (totalPrice) => ({
  type: actionTypes.SET_TOTALPRICE,
  totalPrice,
});

// Menghitung total harga berdasarkan produk yang ada di cart
export const getTotalPrice = (data) => (dispatch) => {
  const content = store.getState().order; // Mengambil state order
  const product = data;

  if (product?.length > 0 && Object.keys(content).length > 0) {
    // Membuat array asosiatif untuk produk
    const productMap = product.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    // Menghitung total harga
    const totalPrice = Object.keys(content).reduce(
      (sum, key) => sum + (productMap[key]?.promoPrice || 0) * content[key],
      0
    );

    dispatch(setTotalPrice(totalPrice));
  } else {
    dispatch(setTotalPrice(0));
  }
};

// Memperbarui total harga dengan nilai tertentu
export const updateTotalPrice = (value) => (dispatch) => {
  const currentTotal = store.getState().products.totalPrice || 0;
  const updatedPrice = value - currentTotal;
  dispatch(setTotalPrice(updatedPrice));
};

// Async action untuk mengambil produk dari API berdasarkan cart
export const retriveProductCart = () => (dispatch) => {
  dispatch(startFetchProduct());
  dispatch(checkToken()); // Mengecek token untuk autentikasi

  const content = store.getState().order; // Mengambil state order

  ProductWhereIn(content)
    .then((res) => {
      const products = res.data;
      dispatch(fetchProduct(products)); // Menyimpan produk ke store
      dispatch(successFetchProduct()); // Menandai bahwa pengambilan berhasil
      dispatch(getTotalPrice(products)); // Menghitung total harga
    })
    .catch((error) => {
      console.error('Error fetching product cart:', error);
    });
};
